import styles from "./KeyringRectangle_Reusable.module.css";

import sample from "../../../assets/images/edit_screen/WoodenPlateSquare/Edit_Image.png";

import sample_1 from "../../../assets/images/edit_screen/WoodenPlateSquare/vertical_upload.png";

// import edit_1 from "../../../assets/images/edit_screen/KeyringRectangle/edit_1.png";

// import edit_2 from "../../../assets/images/edit_screen/KeyringRectangle/edit_2.png";

import sample_2 from "../../../assets/images/edit_screen/WoodenPlateSquare/horizontal_upload.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import EditScreenImageTextPlacement from "../../Reusables/EditScreenImageTextPlacement";
import gallery_icon from "../../../assets/images/icons/gallery_ace.svg";
import EditScreenSelector from "../../Reusables/EditScreenSelector";
import EditScreenTextPositionSelection from "../../Reusables/EditScreenTextPositionSelection";

import html2canvas from "html2canvas-support-css";
import domtoimage from "dom-to-image";

const KeyringRectangleReusable = React.forwardRef((props, ref) => {
  const {
    index,
    callback,
    callbackPreviewChange,
    state,
    image_selection_popup,
    //new stuff
    saveThisProduct,
    changeCopyDetails,
    selectedCopyDetails,
    currentPageNumber,
    totalPageNumber,
    confirmEdits,
    generatePreviewsAtBottom,
    preview_copied_image,
  } = props;
  const { edit_1, edit_2, imageHasBeenUploaded1, imageHasBeenUploaded2 } =
    state;
  const previewSectionRef = useRef(null);
  const changeStateMultiple = (keys, values) => {
    for (let i = 0; i < keys.length; i++) {
      state[keys[i]] = values[i];
    }
    callback(state);
  };
  const changePreview = async () => {
    try {
      handleSave1();
      handleSave2();
      previewSectionRef.current.style.display = "block";

      // Wait for the elements to become visible
      await new Promise((resolve) => setTimeout(resolve, 100));

      const canvas = await html2canvas(previewRef.current, {
        logging: true,
        allowTaint: true,
      });
      console.log("saving image again");
      return new Promise((resolve) => {
        canvas.toBlob((blob) => {
          console.log(edit_1);
          console.log(edit_2);
          console.log("generating the file");
          const file = new File([blob], "image.png", { type: "image/jpg" });
          console.log("Generated the " + currentPageNumber + " file");
          previewSectionRef.current.style.display = "none";
          console.log(file);
          resolve(file);
        });
      });
    } catch (e) {
      console.log(e);
      return false;
    }
  };

  const changePreview2 = async () => {
    console.log("changed preview image");

    try {
      //hiding the previewSection
      previewSectionRef.current.style.display = "block";

      // Wait for the elements to become visible
      await new Promise((resolve) => setTimeout(resolve, 100));
      handleSave1();
      handleSave2();
      // await loadAllFonts();

      const blob = await domtoimage.toBlob(previewRef.current, {
        bgcolor: "white",
      });
      console.log("saving image again");
      const file = new File([blob], "image.png", { type: "image/jpg" });
      previewSectionRef.current.style.display = "none";
      return file;
    } catch (e) {
      console.log("something went wrong generating preview");
      console.log(e);
      return false;
    }
  };

  const changePreview1 = async () => {
    console.log("changed preview image");

    try {
      const blob = await domtoimage.toBlob(previewRef.current, {
        bgcolor: "white",
      });
      console.log("saving image again");
      const file = new File([blob], "image.png", { type: "image/jpg" });
      callbackPreviewChange(index, file);
      return file;
    } catch (e) {
      console.log(e);
      return false;
    }
  };
  const uploadNewImage = (num) => {
    // saveState();
    if (num === 0) {
      if (imageHasBeenUploaded1 || imageHasBeenUploaded2) return;
      image_selection_popup(index, 2);
    } else {
      if (
        (num === 1 && imageHasBeenUploaded1) ||
        (num === 2 && imageHasBeenUploaded2)
      )
        return;
      image_selection_popup(index, 1, num);
    }
  };
  useImperativeHandle(ref, () => ({
    changePreview,
  }));

  const previewRef = useRef();

  const divRef1 = useRef(null);
  const imgRef1 = useRef(null);
  const canvasRef1 = useRef(null);
  const [editedImgSrc1, setEditedImgSrc1] = useState("");
  const [imgRect1, setImgRect1] = useState(null);
  const [divRect1, setDivRect1] = useState(null);
  const [reworkedWidth1, setReworkedWidth1] = useState(350);
  const [reworkedHeight1, setReworkedHeight1] = useState(350);

  const [zoomLevel1, setZoomLevel1] = useState(1);
  const [isPanning1, setPanning1] = useState(false);
  const [image1, setImage1] = useState("");
  const [showPreview, setShowPreview] = useState(false);
  const [position1, setPosition1] = useState({
    oldX: 0,
    oldY: 0,
    x: 0,
    y: 0,
    z: 1,
  });

  const containerRef1 = useRef(null);

  const handleSave1 = () => {
    checkImage1();
    const canvas = canvasRef1.current;
    const ctx = canvas.getContext("2d");
    console.log("handling save");
    canvas.toBlob(function (blob) {
      const url = URL.createObjectURL(blob);
      setEditedImgSrc1(url);
    });
  };
  const handleSave2 = () => {
    checkImage2();
    const canvas = canvasRef2.current;
    const ctx = canvas.getContext("2d");
    console.log("handling save");
    canvas.toBlob(function (blob) {
      const url = URL.createObjectURL(blob);
      setEditedImgSrc2(url);
    });
  };
  const divRef2 = useRef(null);
  const imgRef2 = useRef(null);
  const canvasRef2 = useRef(null);
  const [editedImgSrc2, setEditedImgSrc2] = useState("");
  const [imgRect2, setImgRect2] = useState(null);
  const [divRect2, setDivRect2] = useState(null);
  const [reworkedWidth2, setReworkedWidth2] = useState(350);
  const [reworkedHeight2, setReworkedHeight2] = useState(350);
  const [zoomLevel2, setZoomLevel2] = useState(1);
  const [isPanning2, setPanning2] = useState(false);
  const [image2, setImage2] = useState("");
  const [position2, setPosition2] = useState({
    oldX: 0,
    oldY: 0,
    x: 0,
    y: 0,
    z: 1,
  });

  const containerRef2 = useRef(null);
  const [uploadedImageVertical1, setUploadedImageVertical1] = useState(false);
  const [uploadedImageVertical2, setUploadedImageVertical2] = useState(false);

  const checkImage1 = () => {
    if (!divRect1 || !imgRect1 || !containerRef1 || !containerRef1.current) {
      return;
    }
    const canvas = canvasRef1.current;
    const ctx = canvas.getContext("2d");
    const containerRect = containerRef1.current.getBoundingClientRect();
    canvas.width = uploadedImageVertical1 ? 330 : 450;
    canvas.height = uploadedImageVertical1 ? 450 : 330;
    // ctx.setTransform(position.z, 0, 0, position.z, position.x, position.y);
    const imageWidth = divRect1.width;
    const imageHeight = divRect1.height;
    const centerX = imageWidth / 2 + position1.x;
    const centerY = imageHeight / 2 + position1.y;
    ctx.translate(centerX, centerY);
    ctx.scale(position1.z, position1.z);
    ctx.translate(-centerX, -centerY);
    ctx.translate(position1.x, position1.y);
    if (uploadedImageVertical1) {
      ctx.drawImage(imgRef1.current, 0, 0, canvas.width, canvas.height);
    } else {
      ctx.drawImage(imgRef1.current, 0, -25, canvas.width, canvas.height);
    }
    // ctx.drawImage(imgRef.current, 0, 0, divRect.width, divRect.height);
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    ctx.putImageData(imageData, 0, 0);
  };

  const checkImage2 = () => {
    if (!divRect2 || !imgRect2 || !containerRef2 || !containerRef2.current) {
      return;
    }
    const canvas = canvasRef2.current;
    const ctx = canvas.getContext("2d");
    const containerRect = containerRef2.current.getBoundingClientRect();
    canvas.width = uploadedImageVertical2 ? 330 : 450;
    canvas.height = uploadedImageVertical2 ? 450 : 330;

    // ctx.setTransform(position.z, 0, 0, position.z, position.x, position.y);
    const imageWidth = divRect2.width;
    const imageHeight = divRect2.height;
    const centerX = imageWidth / 2 + position2.x;
    const centerY = imageHeight / 2 + position2.y;
    ctx.translate(centerX, centerY);
    ctx.scale(position2.z, position2.z);
    ctx.translate(-centerX, -centerY);
    ctx.translate(position2.x, position2.y);

    if (uploadedImageVertical2) {
      ctx.drawImage(imgRef2.current, 0, 0, canvas.width, canvas.height);
    } else {
      ctx.drawImage(
        imgRef2.current,
        0,
        25,
        canvas.width - 25,
        canvas.height - 50
      );
    }
    // ctx.drawImage(imgRef.current, 0, 0, divRect.width, divRect.height);
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    ctx.putImageData(imageData, 0, 0);
  };
  const onLoad1 = (e) => {
    setImage1({
      width: e.target.naturalWidth,
      height: e.target.naturalHeight,
    });
    const aspectRatio = e.target.naturalWidth / e.target.naturalHeight;
    if (aspectRatio > 1) {
      setUploadedImageVertical1(false);
      setReworkedWidth1(280 * aspectRatio);
      setReworkedHeight1(280);
      setPosition1({
        ...position1,

        y: 25,
      });
    } else {
      setUploadedImageVertical1(true);
      setReworkedHeight1(280 / aspectRatio);
      setReworkedWidth1(280);
      setPosition1({
        ...position1,

        x: 25,
      });
    }

    setImgRect1(imgRef1.current.getBoundingClientRect());
    setDivRect1(divRef1.current.getBoundingClientRect());
  };

  const onLoad2 = (e) => {
    setImage2({
      width: e.target.naturalWidth,
      height: e.target.naturalHeight,
    });
    const aspectRatio = e.target.naturalWidth / e.target.naturalHeight;
    if (aspectRatio > 1) {
      setUploadedImageVertical2(false);
      setReworkedWidth2(280 * aspectRatio);
      setReworkedHeight2(280);
      setPosition2({
        ...position2,
        y: 25,
      });
    } else {
      setUploadedImageVertical2(true);
      setReworkedHeight2(280 / aspectRatio);
      setReworkedWidth2(280);
      setPosition2({
        ...position2,

        x: 25,
      });
    }

    setImgRect2(imgRef2.current.getBoundingClientRect());
    setDivRect2(divRef2.current.getBoundingClientRect());
  };

  const onMouseDown1 = (e) => {
    e.preventDefault();
    setPanning1(true);
    console.log(position1);
    setPosition1({
      ...position1,
      oldX: e.clientX,
      oldY: e.clientY,
    });
  };

  const onMouseDown2 = (e) => {
    e.preventDefault();
    setPanning2(true);
    console.log(position2);
    setPosition2({
      ...position2,
      oldX: e.clientX,
      oldY: e.clientY,
    });
  };

  const zoom1 = (val) => {
    if ((zoomLevel1 === 6 && val < 0) || (zoomLevel1 === 1 && val > 0)) {
      return;
    } else {
      setZoomLevel1(val < 0 ? zoomLevel1 + 1 : zoomLevel1 - 1);
    }
    const sign = val;
    const scale = 1 - sign;
    console.log(scale);

    const rect = containerRef1.current.getBoundingClientRect();
    const cx = (rect["left"] + rect["right"]) / 2;
    const cy = (rect["top"] + rect["bottom"]) / 2;

    setPosition1({
      ...position1,
      x: position1.x * scale - (rect.width / 2 - cx + rect.x) * sign,
      y:
        position1.y * scale -
        ((image1.height * rect.width) / image1.width / 2 - cy + rect.y) * sign,
      z: val > 0 && zoomLevel1 - 2 === 0 ? 1 : position1.z * scale,
    });
  };
  const zoom2 = (val) => {
    let zl = zoomLevel2;
    if ((zoomLevel2 === 6 && val < 0) || (zoomLevel2 === 1 && val > 0)) {
      return;
    } else {
      zl = val < 0 ? zoomLevel2 + 1 : zoomLevel2 - 1;
    }
    if (zl === 0) {
      resetPosition2();
    }
    setZoomLevel2(zl);
    const sign = val;
    const scale = 1 - sign;
    console.log(scale);

    const rect = containerRef2.current.getBoundingClientRect();
    const cx = (rect["left"] + rect["right"]) / 2;
    const cy = (rect["top"] + rect["bottom"]) / 2;

    setPosition2({
      ...position2,
      x: position2.x * scale - (rect.width / 2 - cx + rect.x) * sign,
      y:
        position2.y * scale -
        ((image2.height * rect.width) / image2.width / 2 - cy + rect.y) * sign,
      z: val > 0 && zoomLevel2 - 2 === 0 ? 1 : position2.z * scale,
    });
  };

  useEffect(() => {
    const mouseup1 = () => {
      console.log("Panning 01");
      setPanning1(false);
      console.log(reworkedHeight1);
      console.log(reworkedWidth1);
    };

    const mousemove1 = (event) => {
      if (isPanning1) {
        let newX = position1.x + event.clientX - position1.oldX;
        let newY = position1.y + event.clientY - position1.oldY;

        setPosition1({
          ...position1,

          x: newX,
          y: newY,
          oldX: event.clientX,
          oldY: event.clientY,
        });
      }
    };

    window.addEventListener("mouseup", mouseup1);
    window.addEventListener("mousemove", mousemove1);

    return () => {
      window.removeEventListener("mouseup", mouseup1);
      window.removeEventListener("mousemove", mousemove1);
    };
  });
  useEffect(() => {
    const mouseup2 = () => {
      setPanning2(false);
      console.log("Panning 02");
      console.log(reworkedHeight2);
      console.log(reworkedWidth2);
    };

    const mousemove2 = (event) => {
      if (isPanning2) {
        let newX = position2.x + event.clientX - position2.oldX;
        let newY = position2.y + event.clientY - position2.oldY;

        setPosition2({
          ...position2,

          x: newX,
          y: newY,
          oldX: event.clientX,
          oldY: event.clientY,
        });
      }
    };

    window.addEventListener("mouseup", mouseup2);
    window.addEventListener("mousemove", mousemove2);

    return () => {
      window.removeEventListener("mouseup", mouseup2);
      window.removeEventListener("mousemove", mousemove2);
    };
  });
  const resetPosition1 = () => {
    setPosition1({
      oldX: 0,
      oldY: 0,
      x: 0,
      y: 0,
      z: 1,
    });
  };
  const resetPosition2 = () => {
    setPosition2({
      oldX: 0,
      oldY: 0,
      x: 0,
      y: 0,
      z: 1,
    });
  };
  const downloadBlackBorderImage = () => {
    const imgEl = document.getElementById("pan_and_zoom_imageid");
    const blackborderEl = document.getElementById("edit_image_blackborderid");
    const blackborderRect = blackborderEl.getBoundingClientRect();

    console.log("goes deep 1");
    domtoimage
      .toJpeg(imgEl)
      .then(function (dataUrl) {
        var canvas = document.createElement("canvas");

        console.log("goes deep 2");
        canvas.width = blackborderRect.width;
        canvas.height = blackborderRect.height;
        var ctx = canvas.getContext("2d");
        ctx.setTransform(
          position1.z, // Horizontal scaling
          0, // Horizontal skewing
          0, // Vertical skewing
          position1.z, // Vertical scaling
          -position1.x +
            (blackborderRect.width - imgRect2.width * position1.z) / 2, // Horizontal translation
          -position1.y +
            (blackborderRect.height - imgRect2.height * position1.z) / 2 // Vertical translation
        );
        // Set the clip-path of the image element to match the dimensions of the black border div
        imgEl.style.clipPath = `inset(${blackborderRect.y}px ${
          blackborderRect.x
        }px ${blackborderRect.y + blackborderRect.height}px ${
          blackborderRect.x + blackborderRect.width
        }px)`;

        // Load the clipped image into a separate Image object
        var clippedImg = new Image();
        clippedImg.onload = function () {
          console.log("inside the onload function");
          // Draw clipped image onto canvas
          ctx.drawImage(clippedImg, 0, 0);

          var croppedDataUrl = canvas.toDataURL();
          console.log("goes deep 3");
          // Create an anchor element
          var link = document.createElement("a");
          link.href = croppedDataUrl;
          link.download = "cropped-image2.png"; // Set the filename here

          // Programmatically click the anchor element to download the file
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          // Reset the clip-path of the image element
          imgEl.style.clipPath = "none";
        };
        clippedImg.onerror = function (error) {
          console.error(error);
        };
        clippedImg.src = dataUrl;
      })
      .catch(function (error) {
        console.error(error);
      });
  };

  //new 1
  const copyOptions = [];
  for (let i = 1; i < currentPageNumber; i++) {
    copyOptions.push(i + "個目と同じ");
  }
  copyOptions.push("別のデザインで作る");
  // let copySelected =
  //   selectedCopyDetails === currentPageNumber
  //     ? currentPageNumber + "個目の写真"
  //     : selectedCopyDetails+"個目の写真";
  let copySelected = selectedCopyDetails + "個目の写真";
  const extractNumber = (s, currentPageNumber, totalPageNumber) => {
    for (let i = totalPageNumber; i > 0; i--) {
      if (s.includes(i)) {
        return i;
      }
    }
    return currentPageNumber;
  };

  return (
    <div className={styles.main_div}>
      <div className={styles.top_hr}></div>
      <div className={styles.info_section_main01}>
        <div className={styles.header_section_main}>
          {currentPageNumber === 1 && (
            <div name="編　集" className={styles.header_section}>
              編　　集
            </div>
          )}

          {totalPageNumber > 1 && (
            <div
              className={styles.header_number}
              name={"editsection" + currentPageNumber}
            >
              {currentPageNumber + "個目"}
            </div>
          )}
        </div>
        <div className={styles.upload_section_main}>
          {currentPageNumber > 1 && (
            <div className={styles.multi_page_selector}>
              <EditScreenSelector
                takeupspace={true}
                options={copyOptions}
                callback={(value) => {
                  console.log(value);
                  changeCopyDetails(
                    extractNumber(value, currentPageNumber, totalPageNumber),
                    index
                  );
                  // changeState("sec03textbox", value);
                  // setSec03textbox(value);
                }}
                selected={copySelected}
              />
            </div>
          )}
          {selectedCopyDetails === currentPageNumber && (
            <div className={styles.upload_section_sec_main}>
              <div className={styles.edit_title_text_01}>
                両面（2枚）写真選択してください。
              </div>
              <div
                onClick={(event) => {
                  uploadNewImage(0);
                }}
                className={styles.upload_image_placeholder}
              >
                <img
                  className={styles.upload_image_gallery_icon}
                  src={gallery_icon}
                  alt="top_gallery"
                />

                <div className={styles.upload_image_placeholder_text}>
                  写真選択
                </div>
              </div>
              <div className={styles.top_text_03}>
                縦写真は縦向きに、横写真は横向きに仕上がります。
              </div>
            </div>
          )}
        </div>
      </div>

      <div className={styles.top_hr02}></div>
      {selectedCopyDetails === currentPageNumber && (
        <>
          <div className={styles.spacing02}></div>
          <div className={styles.top_text02}>
            選択した写真は拡大が可能です。
          </div>
          <div className={styles.top_text02}>
            お好みの画像倍率に設定し、カーソルで位置を決定してください。
          </div>
          <div className={styles.spacing03}></div>
          <div className={styles.edit_body_section}>
            <div className={styles.edit_image_with_zoom}>
              <div className={styles.edit_image_section}>
                {!imageHasBeenUploaded1 && (
                  <div
                    onClick={(event) => {
                      uploadNewImage(1);
                    }}
                    className={styles.upload_image_placeholder}
                  >
                    <img
                      className={styles.upload_image_gallery_icon}
                      src={gallery_icon}
                      alt="top_gallery"
                    />

                    <div className={styles.upload_image_placeholder_text}>
                      写真選択
                    </div>
                  </div>
                )}
                {imageHasBeenUploaded1 && (
                  <div
                    style={{
                      width: !uploadedImageVertical1 ? "450px" : "330px",
                      height: uploadedImageVertical1 ? "450px" : "330px",
                    }}
                    className={styles.col_1_image_square}
                  >
                    {/* <img  src={sample} alt="sample" /> */}
                    <div
                      style={{
                        width: !uploadedImageVertical1 ? "450px" : "330px",
                        height: uploadedImageVertical1 ? "450px" : "330px",
                      }}
                      className={styles.pan_and_zoom_container}
                      ref={containerRef1}
                      onMouseDown={onMouseDown1}
                    >
                      <div
                        ref={divRef1}
                        style={{
                          transform: `translate(${position1.x}px, ${position1.y}px) scale(${position1.z})`,
                        }}
                      >
                        <img
                          ref={imgRef1}
                          style={{
                            minWidth: !uploadedImageVertical1
                              ? reworkedWidth1 + "px"
                              : "330px",
                            maxHeight: !uploadedImageVertical1 ? "280px" : "",

                            minHeight: uploadedImageVertical1
                              ? reworkedHeight1 + "px"
                              : "",
                            maxWidth: uploadedImageVertical1 ? "330px" : "",
                          }}
                          className={styles.pan_and_zoom_image}
                          alt="floorplan"
                          src={edit_1}
                          onLoad={onLoad1}
                          crossOrigin="anonymous"
                        />
                      </div>
                      <div
                        style={{
                          width: !uploadedImageVertical1 ? "400px" : "280px",
                          height: uploadedImageVertical1 ? "400px" : "280px",
                        }}
                        className={styles.edit_image_blackborder}
                      ></div>
                      <div
                        style={{
                          width: !uploadedImageVertical1 ? "450px" : "330px",
                          height: uploadedImageVertical1 ? "450px" : "330px",
                        }}
                        className={styles.edit_image_frame}
                      ></div>
                    </div>
                    <div
                      onClick={() => {
                        console.log("Cross the image");
                        setEditedImgSrc1("");
                        changeStateMultiple(
                          ["imageHasBeenUploaded1", "edit_1"],
                          [false, ""]
                        );
                      }}
                      className={styles.cross_div}
                    >
                      <ion-icon
                        className={styles.cross_icon}
                        name="close"
                      ></ion-icon>
                    </div>
                  </div>
                )}
              </div>
              <div className={styles.zoom_col_1}>
                {imageHasBeenUploaded1 && (
                  <div className={styles.zoom_section}>
                    <i
                      onClick={() => {
                        zoom1(0.1);
                      }}
                      className={
                        "fa fa-search-minus " +
                        styles.zoom_icon +
                        " " +
                        styles.minus_icon
                      }
                      aria-hidden="true"
                    ></i>
                    <i
                      onClick={() => {
                        zoom1(-0.1);
                      }}
                      className={
                        "fa fa-search-plus " +
                        styles.zoom_icon +
                        " " +
                        styles.plus_icon
                      }
                      aria-hidden="true"
                    ></i>
                  </div>
                )}
                {imageHasBeenUploaded1 && (
                  <div className={styles.uploaded_image_text_01}>
                    <div>黒枠が出来上がり線です。</div>
                    <div className={styles.uploaded_image_text_01_div2}>
                      カーソルを移動し、位置を調整してください。
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className={styles.edit_image_with_zoom}>
              <div className={styles.edit_image_section}>
                {!imageHasBeenUploaded2 && (
                  <div
                    onClick={(event) => {
                      uploadNewImage(2);
                    }}
                    className={styles.upload_image_placeholder}
                  >
                    <img
                      className={styles.upload_image_gallery_icon}
                      src={gallery_icon}
                      alt="top_gallery"
                    />

                    <div className={styles.upload_image_placeholder_text}>
                      写真選択
                    </div>
                  </div>
                )}
                {imageHasBeenUploaded2 && (
                  <div
                    style={{
                      width: !uploadedImageVertical2 ? "450px" : "330px",
                      height: uploadedImageVertical2 ? "450px" : "330px",
                    }}
                    className={styles.col_1_image_square}
                  >
                    {/* <img  src={sample} alt="sample" /> */}
                    <div
                      style={{
                        width: !uploadedImageVertical2 ? "450px" : "330px",
                        height: uploadedImageVertical2 ? "450px" : "330px",
                      }}
                      className={styles.pan_and_zoom_container}
                      ref={containerRef2}
                      onMouseDown={onMouseDown2}
                    >
                      <div
                        ref={divRef2}
                        style={{
                          transform: `translate(${position2.x}px, ${position2.y}px) scale(${position2.z})`,
                        }}
                      >
                        <img
                          ref={imgRef2}
                          style={{
                            minWidth: !uploadedImageVertical2
                              ? reworkedWidth2 + "px"
                              : "330px",
                            maxHeight: !uploadedImageVertical2 ? "280px" : "",

                            minHeight: uploadedImageVertical2
                              ? reworkedHeight2 + "px"
                              : "",
                            maxWidth: uploadedImageVertical2 ? "330px" : "",
                          }}
                          id={"pan_and_zoom_imageid"}
                          className={styles.pan_and_zoom_image}
                          alt="floorplan"
                          src={edit_2}
                          onLoad={onLoad2}
                          crossOrigin="anonymous"
                        />
                      </div>
                      <div
                        style={{
                          width: !uploadedImageVertical2 ? "400px" : "280px",
                          height: uploadedImageVertical2 ? "400px" : "280px",
                        }}
                        id={"edit_image_blackborderid"}
                        className={styles.edit_image_blackborder}
                      ></div>
                      <div
                        style={{
                          width: !uploadedImageVertical2 ? "450px" : "330px",
                          height: uploadedImageVertical2 ? "450px" : "330px",
                        }}
                        className={styles.edit_image_frame}
                      ></div>
                    </div>
                    <div
                      onClick={() => {
                        console.log("Cross the image");
                        setEditedImgSrc2("");
                        changeStateMultiple(
                          ["imageHasBeenUploaded2", "edit_2"],
                          [false, ""]
                        );
                      }}
                      className={styles.cross_div}
                    >
                      <ion-icon
                        className={styles.cross_icon}
                        name="close"
                      ></ion-icon>
                    </div>
                  </div>
                )}
              </div>
              <div className={styles.zoom_col_2}>
                {imageHasBeenUploaded2 && (
                  <div className={styles.zoom_section}>
                    <i
                      onClick={() => {
                        zoom2(0.1);
                      }}
                      className={
                        "fa fa-search-minus " +
                        styles.zoom_icon +
                        " " +
                        styles.minus_icon
                      }
                      aria-hidden="true"
                    ></i>
                    <i
                      onClick={() => {
                        zoom2(-0.1);
                      }}
                      className={
                        "fa fa-search-plus " +
                        styles.zoom_icon +
                        " " +
                        styles.plus_icon
                      }
                      aria-hidden="true"
                    ></i>
                  </div>
                )}
                {imageHasBeenUploaded2 && (
                  <div className={styles.uploaded_image_text_01}>
                    <div>黒枠が出来上がり線です。</div>
                    <div className={styles.uploaded_image_text_01_div2}>
                      カーソルを移動し、位置を調整してください。
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className={styles.zoom_entire_container}></div>
        </>
      )}

      {/* dummy canvas DO NOT REMOVE */}
      <canvas ref={canvasRef1} style={{ display: "none" }}></canvas>
      <canvas ref={canvasRef2} style={{ display: "none" }}></canvas>
      {totalPageNumber === 1 && (
        <div className={styles.edit_done_button_div}>
          <button
            className={styles.edit_done_button}
            onClick={() => {
              handleSave1();
              handleSave2();
              setShowPreview(true);
              // downloadBlackBorderImage();
            }}
          >
            プレビュー
          </button>
        </div>
      )}
      {selectedCopyDetails === currentPageNumber && totalPageNumber > 1 && (
        <div className={styles.edit_done_button_div}>
          <button
            className={styles.edit_done_multiple_button}
            onClick={() => {
              console.log("Save Multiple Page");
              handleSave1();
              handleSave2();
              setShowPreview(true);
              // downloadBlackBorderImage();
            }}
          >
            {currentPageNumber + "個目を保存"}
          </button>
        </div>
      )}

      {showPreview && <div className={styles.top_hr03}></div>}

      {showPreview && (
        <div ref={previewSectionRef} className={styles.preview_section}>
          <div className={styles.preview_header_text_section}>
            <div className={styles.preview_header}>イメージプレビュー</div>
          </div>
          <div ref={previewRef} className={styles.preview_image_row}>
            <div className={styles.preview_image_div}>
              <div
                style={{
                  height: !uploadedImageVertical1 ? 350 : 450,
                  width: uploadedImageVertical1 ? 350 : 450,
                }}
                className={styles.edit_done_image_div}
              >
                <img
                  style={{
                    height: !uploadedImageVertical1 ? 300 : 450,
                    width: uploadedImageVertical1 ? 300 : 450,

                    objectFit: "cover",
                    objectPosition: "center",
                  }}
                  className={styles.edited_done_image}
                  src={editedImgSrc1}
                  alt="edited"
                />

                <div
                  style={{
                    height: !uploadedImageVertical1 ? 300 : 450,
                    width: uploadedImageVertical1 ? 300 : 450,
                  }}
                  className={styles.frame02}
                ></div>
              </div>
            </div>
            <div className={styles.preview_image_div}>
              <div
                style={{
                  height: !uploadedImageVertical2 ? 350 : 450,
                  width: uploadedImageVertical2 ? 350 : 450,
                }}
                className={styles.edit_done_image_div}
              >
                <img
                  style={{
                    height: !uploadedImageVertical2 ? 300 : 450,
                    width: uploadedImageVertical2 ? 300 : 450,

                    objectFit: "cover",
                    objectPosition: "center",
                  }}
                  className={styles.edited_done_image}
                  src={editedImgSrc2}
                  alt="edited"
                />

                <div
                  style={{
                    height: !uploadedImageVertical2 ? 300 : 450,
                    width: uploadedImageVertical2 ? 300 : 450,
                  }}
                  className={styles.frame02}
                ></div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
});
export default KeyringRectangleReusable;
